angular.module('AccountingBoxApp')
.controller('JournalEntriesListCtrl', function($scope, $location, $filter, $stateParams, $state, JournalEntry) {

  //  var table = $('#dataTable');
  $scope.order= {
    by:'journalDate',
    reverse: true,
    filter:''
  };

  var vm = this;
  vm.loading = true;
  var journalEntries = JournalEntry.find({filter: {
      // fields: {
      //   id: true,
      //   journalDate: true,
      //   description: true,
      //   totalAmount: true,
      //   Lines: true,
      // }
    }},function(journalEntries){
    vm.loading = false;
  });

  vm.journalEntries = journalEntries;
  vm.viewjournalEntry = function(journalEntryId) {
    $state.go('app.company.edit.journalEntries', { id: journalEntryId });
    //$state.go('view',({id: 1434}));
  };
  vm.editjournalEntry = function(journalEntryId) {
    alert(journalEntryId);
    $state.go('app.company.edit.journalEntries',{id:journalEntryId});
  };
  vm.newjournalEntry = function(){
    $state.go('app.company.new.journalEntries');
  };
});
